import { GithubIcon, GitlabIcon } from 'lucide-react';
import { OAuthConnection } from '../../services/RepositoryService';
import { logger } from '../../utils/logger';
import { ProviderTab } from './types';

export const CONNECTION_STORAGE_KEY = 'selected_connection_ids';

export const readStoredConnectionSelection = (): Record<ProviderTab, string | null> => {
  if (typeof window === 'undefined') {
    return { github: null, gitlab: null };
  }
  try {
    const stored = window.localStorage.getItem(CONNECTION_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        github: parsed.github ?? null,
        gitlab: parsed.gitlab ?? null,
      };
    }
  } catch (err) {
    logger.warn('[OAuth] Failed to parse saved connection selection', { error: err });
  }
  return { github: null, gitlab: null };
};

export const hasRequiredScopes = (connection: OAuthConnection | undefined): boolean => {
  if (!connection) return false;

  const requiredScopes =
    connection.provider === 'github'
      ? ['repo', 'read:org']
      : connection.provider === 'gitlab'
        ? ['api']
        : [];

  return requiredScopes.every((scope) => connection.scopes.some((s) => s.includes(scope)));
};

export const getProviderIcon = (provider: ProviderTab) => {
  switch (provider) {
    case 'github':
      return <GithubIcon className="w-5 h-5" />;
    case 'gitlab':
      return <GitlabIcon className="w-5 h-5" />;
  }
};

export const getProviderColor = (provider: ProviderTab) => {
  switch (provider) {
    case 'github':
      return 'text-gray-900 dark:text-white';
    case 'gitlab':
      return 'text-orange-600 dark:text-orange-500';
  }
};
